import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { DeviceDTO as NotificationDeviceDTO } from '@eppendorf/vnls-notifications-utils';
import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import cn from 'classnames';

import { useDeviceType } from '$components/app-config/useDeviceType';
import { DeviceNameOrSerialNumber } from '$components/device/device-name-or-serialnumber/device-name-or-serialnumber';
import { searchDeviceIcon } from '$features/devices/devices.utils';

import styles from './name-cell.module.scss';

interface DeviceNameCellProps {
  device: DeviceDTO | NotificationDeviceDTO | null;
  isIconUnmasked?: boolean;
  className?: string;
}

function normalizeDevice(device: DeviceDTO | NotificationDeviceDTO): DeviceDTO {
  let model = 'model' in device ? device.model : undefined;
  if ('deviceModel' in device && !model) {
    model = device.deviceModel;
  }

  let type = 'type' in device ? device.type : undefined;
  if ('deviceType' in device && !type) {
    type = device.deviceType;
  }

  let name = 'name' in device ? device.name : undefined;
  if ('deviceName' in device && !name) {
    name = device.deviceName;
  }
  return {
    ...device,
    model,
    type,
    name,
  };
}

export function DeviceNameCell({
  device,
  isIconUnmasked,
  className,
}: DeviceNameCellProps) {
  const normalizedDevice = device ? normalizeDevice(device) : null;
  const deviceType = useDeviceType(normalizedDevice);

  return normalizedDevice ? (
    <div className={cn(styles.deviceNameCell, className)}>
      <div className={styles.deviceNameCellIconWrapper}>
        <Icon
          size={IconSizeClasses.Small}
          name={searchDeviceIcon(
            deviceType as string,
            isIconUnmasked,
            normalizedDevice?.model,
          )}
        />
      </div>

      <div className={styles.deviceNameCellLabel}>
        <div className={styles.deviceNameCellTitle}>
          <DeviceNameOrSerialNumber device={normalizedDevice || undefined} />
        </div>
        <div className={styles.deviceNameCellModel}>
          {normalizedDevice?.manufacturer} {normalizedDevice?.model}
        </div>
      </div>
    </div>
  ) : null;
}
